<script lang="ts">
export interface PhxsgVisuallyHiddenProps {
  use?: string;
}
</script>

<script setup lang="ts">
const { use = 'span' } = defineProps<PhxsgVisuallyHiddenProps>();
</script>

<template>
  <component :is="use" class="phxsg-visually-hidden">
    <slot />
  </component>
</template>

<style src="./visually-hidden.css" />
